import { ActivityTableRow_ActivityFragment } from 'generated/graphql'

type TGetAddressesTextText = (
  addresses: ActivityTableRow_ActivityFragment['addresses'],
) => string

export const getAddressesText: TGetAddressesTextText = (addresses): string => {
  if (addresses[0]?.isAbroad) {
    return '해외'
  }

  if (addresses.length > 1) {
    return `${addresses[0]?.sido} 외 ${addresses.length - 1}`
  } else if (addresses.length === 1 && addresses[0]) {
    return addresses[0].sido
  } else {
    return '-'
  }
}
